import { render, staticRenderFns } from "./UuidDisplay.vue?vue&type=template&id=2177555e&"
import script from "./UuidDisplay.vue?vue&type=script&lang=js&"
export * from "./UuidDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports